export const toHourFormat = (value: number) => value.toFixed(1) + ' h';



// WEBPACK FOOTER //
// ./src/helpers/format-helper.ts